import React from "react";

function DeleteIconFilled() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14"
      fill="none"
      viewBox="0 0 12 14"
    >
      <path
        fill="#FF4D4F"
        d="M2.5 14c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 011 12.5v-10H0V1h4V0h4v1h4v1.5h-1v9.991c0 .423-.147.78-.44 1.072A1.45 1.45 0 019.5 14h-7zm7-11.5h-7v10h7v-10zM4 11h1.5V4H4v7zm2.5 0H8V4H6.5v7z"
      ></path>
    </svg>
  );
}

export default DeleteIconFilled;